import { styled } from "@mui/material/styles";
import Page from "../../../components/Page/Page";
import { Typography } from "@mui/material";
import { Icon } from "../../../icons";

export const BookingDetailsContainer = styled(Page)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._600,
  }));

  export const FormPage = styled(Page)(({ theme }) => ({
    position: 'relative',
    marginTop: theme.space._1000,
    width: "100%",
    maxWidth: "1440px",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: theme.space._700,

    "@media (max-width: 900px)": {
      alignItems: "center",
      flexDirection: "column"
    },
  }));

  export const CTAButtonContainer = styled("div")(({ theme }) => ({
    display: "flex",
    paddingTop: theme.space._200,
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch"
  }));
  
  export const ButtonContainer = styled("div")(({ theme }) => ({
    display: "flex",
    paddingTop: theme.space._100,
    justifyContent: "center",
    alignItems: "center"
  }));
  
  export const ButtonLabel = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    fontFamily: theme.fonts.default,
    fontSize: theme.fontSizes.md,
    fontStyle: 'normal',
    fontWeight: theme.fontWeights.semibold,
    lineHeight: theme.lineHeights.short
  }));
  
  export const ButtonIcon = styled(Icon)(({ theme }) => ({
    width: theme.space._450, 
    height: theme.space._450, 
  }));
  
  